import { useEffect } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import { navLinks } from '../../../UseNavLinks';

import UseMeetApprovedRequestData from '../../../state/workflow/meetApprovedRequest/UseMeetApprovedRequestData';

import Constants from '@usas/ui-web/utils/Constants';

const useMeetApprovedRequest = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { meetApprovedRequestState, getMeetApprovedRequest } = UseMeetApprovedRequestData();

  const onApprovedRequestClicked = (e, meetAppReq) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    
    navigate(navLinks.MEET_APPROVED_REQUEST_APPROVALS, { state: { meetAppReq, isRevisit: location.state?.isRevisit } });
  };

  useEffect(() => {
    if (meetApprovedRequestState.isArrayLoaded !== true) {
      if (location.state && location.state?.isRevisit === true) {
        getMeetApprovedRequest(true);
      }
      else {
        getMeetApprovedRequest(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    location,
    Constants,
    meetApprovedRequestState,
    onApprovedRequestClicked
  };
};

export default useMeetApprovedRequest;